<template>
  <div id="apps">
    <div id="app">
      <div class="wrapper" v-if="show == '0'">
        <div v-if="show_header">
          <cp-preheader></cp-preheader>
        </div>
        <router-view />
      </div>
      <div class="wrapper">
        <vue-drawer-layout
          id="nav-drawer"
          ref="drawerLayout"
          :drawer-width="300"
          :drawable-distance="200"
          :content-drawable="true"
          :enable="false"
          :animatable="true"
          :z-index="0"
          :backdrop="false"
          @slide-start="handleSlideStart"
          @slide-move="handleSlideMove"
          @slide-end="handleSlideEnd"
          @mask-click="handleMaskClick"
          class="drawer-black-content"
          v-if="show == '1'"
        >
          <div
            slot="content"
            :content-drawable="true"
            v-bind:class="[
              isWhitebackground === true
                ? 'white-body'
                : 'drawer-body overflow-auto',
              '',
            ]"
          >
            <!-- main-content -->
            <div class="common-nav" style="height: 100%" v-if="show == '1' && lastParam == 'pay'">
              <!-- adding the Header -->

              <PayHeader></PayHeader>
            </div>
            <div class="common-nav" v-if="show == '1' && lastParam == 'tip'">
              <!-- adding the Header -->

              <TipHeader></TipHeader>
            </div>
            <div
              class="common-nav"
              v-if="show == '1' && lastParam == 'jane-auth'"
            >
              <!-- adding the Header -->

              <AuthHeader></AuthHeader>
            </div>
            <div
              class="common-nav"
              v-if="show == '1' && lastParam == 'returns'"
            >
              <!-- adding the Header -->

              <cp-preheader></cp-preheader>
            </div>
            <div
              class="common-nav"
              v-if="show == '1' && lastParam == 'banklinking'"
            >
              <!-- adding the Header -->

              <cp-preheader></cp-preheader>
            </div>
            <div class="common-nav" v-else-if="show == '0'">
              <!-- adding the Header -->
              <cp-heade></cp-heade>
            </div>
            <router-view />
          </div>
        </vue-drawer-layout>
      </div>

      <div>
        <b-modal
          ref="validation-modal"
          hide-footer
          v-b-modal.modal-center
          modal-backdrop
          hide-header
          id="validation-modal"
          centered
        >
          <div class="color">
            <div class="purchaserpower-modal-text">
              <div class="d-flex justify-content-center mb-3">
                <svg v-if="alertType == 'success'" fill="#0aa942" width="78" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 52 52" style="enable-background:new 0 0 52 52;" xml:space="preserve">
                <g><path d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"/><path d="M38.252,15.336l-15.369,17.29l-9.259-7.407c-0.43-0.345-1.061-0.274-1.405,0.156c-0.345,0.432-0.275,1.061,0.156,1.406l10,8C22.559,34.928,22.78,35,23,35c0.276,0,0.551-0.114,0.748-0.336l16-18c0.367-0.412,0.33-1.045-0.083-1.411C39.251,14.885,38.62,14.922,38.252,15.336z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                </svg>
              
                <svg v-if="alertType == 'error'" width="80" fill="#f05f5f" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style="">  <g>    <path d="M437.018,74.987c-99.968-99.977-262.067-99.977-362.035,0c-99.977,99.959-99.977,262.059,0,362.027 c99.968,99.977,262.067,99.977,362.035,0C536.994,337.054,536.994,174.955,437.018,74.987z M418.918,418.914 c-89.984,89.967-235.853,89.967-325.837,0c-89.967-89.975-89.967-235.844,0-325.828c89.984-89.967,235.853-89.967,325.837,0 C508.885,183.07,508.885,328.939,418.918,418.914z"/>  </g></g><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style="">  <g>    <path d="M 270.314 259.421 L 341.727 188.008 C 346.111 183.632 346.111 176.518 341.727 172.141 C 337.35 167.758 330.236 167.758 325.86 172.141 L 254.447 243.554 L 183.033 172.141 C 178.657 167.75 171.543 167.75 167.167 172.141 C 162.783 176.518 162.783 183.632 167.167 188.008 L 238.58 259.421 L 167.167 330.835 C 162.783 335.211 162.783 342.325 167.167 346.702 C 171.543 351.086 178.657 351.086 183.033 346.702 L 254.447 275.288 L 325.86 346.702 C 330.236 351.085 337.35 351.085 341.727 346.702 C 346.111 342.325 346.111 335.211 341.727 330.835 L 270.314 259.421 Z" style=""/>  </g></g><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/><g transform="matrix(0.962608, 0, 0, 0.962608, 4.347751, 3.048281)" style=""/>
                </svg>
              </div>
              <div class="d-block text-center">
                <label class="purchasepower-def-label">
                  {{ error_message }}
                </label>
              </div>
              <br />
              <br />
              <div class="text-center">
                <button
                  type="button"
                  class="mx-auto col-10 offset-1 btn-black mb-0"
                  style="height: 3.75rem; width: 200px;"
                  @click="hidevalidationModal"
                >
                  <label class="purchasepower-modal-ok-label">OK</label>
                </button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import "./assets/styles/main.scss";
</style>
<script>
import api from "./api/login.js";
import accountAPI from "./api/account.js";
import axios from "axios";
import Header from "./components/Layouts/Headers/Header.vue";
import PreHeader from "./components/Layouts/Headers/PreHeader.vue";
import PayHeader from "./components/Layouts/Headers/PayHeader.vue";
import TipHeader from "./components/Layouts/Headers/TipHeader.vue";
import AuthHeader from "./components/Layouts/Headers/AuthHeader.vue";

export default {
  name: "App",
  data() {
    return {
      show: 0,
      consumer_details: JSON.parse(
        localStorage.getItem("consumer_login_response")
      ),
      show_header: false,
      refreshing: false,
      registration: null,
      snackWithButtons: false,
      isWhitebackground: false,
      showCommonheader: true,
      headerType: "",
      showparticipatingmenu: false,
      show_retailer: false,
      header_retailer: false,
      lastParam: "",
      error_message: "",
      alertType: ""
    };
  },

  components: {
    "cp-preheader": PreHeader,
    TipHeader,
    AuthHeader,
    PayHeader
  },

  mounted: function () {
    let self = this;
    //catching the phone otp pin data when emitted

    self.$root.$on("show_header", function (data) {
      if (data == 2) {
        self.show_header = true;
        self.header_retailer = true;
      } else {
        self.show_header = data;
        self.header_retailer = false;
      }
    });
    self.$root.$on("Menu Drawer", function (data) {
      self.handleToggleDrawer();
    });
    this.$root.$on("changeWhiteBackground", function (data) {
      self.isWhitebackground = data[0];
      self.showCommonheader = data[1];
      self.headerType = data[2];
    });
    if (localStorage.getItem("consumer_token") !== null) {
      this.show = 1;
    } else {
      this.show = 0;
    }
  },
  created() {
    if (localStorage.getItem("consumer_token") !== null) {
      this.show = 1;
    } else {
      this.show = 0;
    }
    let sourceOriginOne = "https://jn.opssquad.net";
    let localOrigin = "http://jn.com";
    let sourceOriginTwo = "https://widgethosting-6dcac.web.app";

    window.addEventListener(
      "message",
      (event) => {
        // Do we trust the sender of this message?

        let obj = event.data;

        if (typeof obj == "object" && "intent_id" in obj) {
          var device_identification_id = localStorage.getItem(
            "device_identification_id"
          );

          localStorage.clear();
          localStorage.setItem(
            "device_identification_id",
            device_identification_id
          );
          if ("intent_id" in obj) {
            localStorage.setItem("intent_id", obj.intent_id);
          }
          if ("amount" in obj) {
            if (obj.amount !== null) {
              localStorage.setItem("amount", parseFloat(obj.amount).toFixed(2));
            }
          }

          if ("is_guest" in obj) {
            if (obj.is_guest !== null) {
              localStorage.setItem("is_guest", obj.is_guest);
            }
          }
          if ("tip_amount" in obj) {
            if (obj.tip_amount !== null) {
              if (typeof obj.tip_amount === "undefined") {
                localStorage.setItem("tip_amount", 0.0);
              } else {
                localStorage.setItem("tip_amount", obj.tip_amount.toFixed(2));
              }
            }
          }
          if ("delivery_fee" in obj) {
            if (obj.delivery_fee !== null) {
              if (typeof obj.delivery_fee === "undefined") {
                localStorage.setItem("delivery_fee", 0.0);
              } else {
                localStorage.setItem("delivery_fee", obj.delivery_fee.toFixed(2));
              }
            }
          }
          if ("split_funding_merchant_id" in obj) {
            if (obj.split_funding_merchant_id !== null) {
              if (typeof obj.split_funding_merchant_id === "undefined") {
                localStorage.setItem("split_funding_merchant_id", '');
              } else {
                localStorage.setItem("split_funding_merchant_id", obj.split_funding_merchant_id);
              }
            }
          }
          if ("passthrough" in obj) {
            if (
              obj.passthrough !== null 
            ) {
              localStorage.setItem(
                "passthrough",
                JSON.stringify(obj.passthrough)
              );
            }
          }
          if ("merchant_order_id" in obj) {
            if (obj.merchant_order_id !== null) {
              if (typeof obj.merchant_order_id === "undefined") {
                localStorage.setItem("merchant_order_id", '');
              } else {
                localStorage.setItem("merchant_order_id", obj.merchant_order_id);
              }
            }
          }
          if ("original_merchant" in obj) {
            if (
              obj.original_merchant !== null 
            ) {
              localStorage.setItem("original_merchant", obj.original_merchant);
            }
          }
          if ("need_modification_url" in obj) {
            if (obj.need_modification_url !== null) {
              if (typeof obj.need_modification_url === "undefined") {
                localStorage.setItem("need_modification_url", false);
              }else{
                localStorage.setItem("need_modification_url", obj.need_modification_url);
              }
            }
          }
          if ("auth_id" in obj) {
            if (obj.auth_id !== null) {
              localStorage.setItem("auth_id", obj.auth_id);
              if(localStorage.getItem("is_guest") == "false")
              {
                localStorage.setItem("check_consumer_auth_allow", true);
                this.checkConsumerAuthAllowed();
              }else{
                this.$router.push("/login");
              }

            }else{
                this.$router.push("/login");
              }
          }else{
            this.$router.push("/login");
          }
        }
      },
      false
    );
  },

  methods: {
    
    checkConsumerAuthAllowed() {
      let self = this;
      localStorage.removeItem("check_consumer_auth_allow");
      localStorage.removeItem('store_id');
      self.isLoading = true;
      let responseData = {};
      var request = {
        intent_id: localStorage.getItem("intent_id"),
        auth_id: localStorage.getItem("auth_id"),
      };
      // return false;
      api
        .checkConsumerAuthAllowed(request)
        .then((response) => {
          localStorage.setItem('store_id', response.data.store_id);
          localStorage.setItem("store_name", response.data.store_name);
          localStorage.setItem("integrator_name", response.data.integrator_name);
            localStorage.setItem("last_successful_login_id", response.data.last_successful_login_id);
            localStorage.setItem("refresh_balance_call_required", response.data.refresh_balance_call_required);
          if (response.data.consumer_auth_allowed == 0) {
            self.$router.push("/login");
          } else {
            localStorage.setItem("consumer_token", response.data.token);
            self.getUserdetails();
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          self.showValidationModal(error.response.data.message, 'error');
          if(error.response.data.code == 403) {
            self.invalidIntentIdPostMessage(error.response.data.message);
          }            
        });

    },
    getUserdetails(){
      var self = this;
      accountAPI
      .getUserdetails()
      .then(function (response) {
        if (response.code == 200) {
          localStorage.setItem("show_pp_animation",1);
          localStorage.setItem(
            "consumer_login_response",
            JSON.stringify(response.data)
          );
          self.$router.push("/pay");
        }
      })
      .catch(function (error) {
      });
    },
    invalidIntentIdPostMessage(message) {
      var intent_id = localStorage.getItem("intent_id");
      const res = {
        invalidIntentId: true,
        response: message,
        intent_id: intent_id,
      };
      window.parent.postMessage(res, "*");
    },
    showValidationModal(msg, type) {
      this.error_message = msg;
      this.alertType = type;
      this.$refs["validation-modal"].show();
    },
    hidevalidationModal() {
      this.error_message = "";
      this.alertType = '';
      this.$refs["validation-modal"].hide();
      let intent_id = localStorage.getItem("intent_id");
      const sendParentData = {
        close: true,
        intent_id: intent_id,
      };
      window.parent.postMessage(sendParentData, "*");
    },
    
    handleToggleDrawer() {
      this.$refs.drawerLayout.toggle();
    },
    handleSlideStart() {},
    handleSlideMove(position) {},
    handleSlideEnd(visible) {
      if (visible == false) {
        this.$root.$emit("Menu Drawer Close", [""]);
      } else {
        this.$root.$emit("Menu Drawer Open", [""]);
      }
    },
    handleMaskClick() {
      this.$refs.drawerLayout.toggle(false);
    },
  },
  watch: {
    $route(to, from) {
      var param;
      var lastParam;
      param = window.location.href.split("/");
      lastParam = param.pop();
      this.lastParam = lastParam;
      if (lastParam == "login" || lastParam == "registration" || lastParam == "forgotpassword"  || lastParam == "enterforgotpin" || lastParam == "locateretailer" || lastParam == "retailerdetails" || param.includes("otp-verification")) {
        this.show = 0;
      } else {
        this.show = 1;
      }
    },
  },
};
</script>
<style scoped>
#problematic-account-modal___BV_modal_body_ {
  background-color: #ffffff;
  border-radius: 12px;
  margin: 10px;
}
#problematic-account-modal___BV_modal_content_{
    background-color: #ffffff;

}
</style>



